// import React from "react";
// import { Loader2 } from "lucide-react";
// import bingopayLogo from "../Assets/Images/logo_png_with_shreebalajee (1).png";

// const TableLoader = ({ text = "Fetching ledger records..." }) => {
//   return (
//     <div className="flex flex-col items-center justify-center py-12 px-4 select-none">
//       {/* Branded Logo Container with Subtle Pulse & Shimmer */}
//       <div className="relative flex items-center justify-center mb-4">
//         {/* Glow backdrop */}
//         <div className="absolute w-24 h-12 bg-amber-400/20 rounded-full blur-xl animate-pulse" />
        
//         {/* Logo Card */}
//         <div className="relative z-10 px-4 py-2 bg-white/90 border border-slate-200/80 rounded-2xl shadow-xs flex items-center justify-center">
//           <img
//             src={bingopayLogo}
//             alt="BingoPay"
//             className="h-7 w-auto object-contain"
//           />
//         </div>
//       </div>

//       {/* Loading Text & Spinner */}
//       <div className="flex items-center gap-2 text-xs font-semibold text-slate-600">
//         <Loader2 className="w-3.5 h-3.5 text-blue-600 animate-spin" />
//         <span>{text}</span>
//       </div>
//       <p className="text-[10px] text-slate-400 mt-0.5">Please wait a moment</p>
//     </div>
//   );
// };

// export default TableLoader;

import React from "react";
import bingopayLogo from "../Assets/Images/logo_png_with_shreebalajee (1).png";

const TableLoader = ({ text = "Updating records..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 select-none">
      {/* Brand Mark with Smooth Gentle Pulse */}
      <div className="relative mb-3 flex items-center justify-center">
        <img
          src={bingopayLogo}
          alt="BingoPay"
          className="h-6 w-auto object-contain opacity-90 transition-opacity duration-300"
        />
      </div>

      {/* Minimal Slim Linear Loader */}
      <div className="w-36 h-1 bg-slate-100 rounded-full overflow-hidden relative mb-2.5">
        <div className="absolute inset-y-0 bg-gradient-to-r from-[#0A2540] via-amber-500 to-[#0A2540] w-1/2 rounded-full animate-[shimmer_1.4s_infinite_linear]" />
      </div>

      {/* Subtle Caption */}
      <p className="text-[11px] font-medium text-slate-400 tracking-wide">
        {text}
      </p>

      {/* Shimmer animation style */}
      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }
      `}</style>
    </div>
  );
};

export default TableLoader;